
// import "../assets/css/auth.css"
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hideLoader, showLoader } from '../components/loader';
import zaapLogo from "../assets/img/logo.svg"
import { apiUrl } from '../utils/url';
const ForgetPassword = () => {
    const dispatch = useDispatch();

    const [values, setvalues] = useState({
        email: null
    });
    const [error, setError] = useState([])

    const formSubmit = (e) => {
        e.preventDefault();
        showLoader()

        const formdata = new FormData()
        for (const key in values) {
            if (Object.hasOwnProperty.call(values, key)) {
                formdata.append(key, values[key]);
            }
        }
        fetch(apiUrl + "/forgot-password", {
            body: formdata,
            method: "POST"
        }).then(async (res) => {
            hideLoader()
            const response = await res?.json()
            if (response?.status_code == 200) {
                toast.success(response?.status_message)
            }
            else {
                if (response?.errors) {
                    const errorList = [];
                    response?.errors?.map((val) => errorList.push(val))
                    setError(errorList)
                    if (response?.status_message)
                        toast.error(response?.status_message);
                }
                else {
                    toast.error(response?.status_message);
                }
            }
        }).catch((err) => {
            hideLoader()
            
// console.log(err?.response?.data?.message)
        })

    }
    const handleChange = (e) => {
        setvalues({ ...values, [e.target.name]: e.target.value })
    }

    return (
        <div id="wrapper">
            <nav id="navbar" class="ps-3 pt-2 navbar bavbar-main navbar-expand-lg navbar-light">
                <div class="">
                    <div class="p-lg-0 p-md-0 p-sm-2">
                        <a class="navbar-brand" href="https://zaap.ai/">
                            <img src={zaapLogo}
                                class="img-fluid navbar-logo" alt="Website Logo" />
                        </a>
                    </div>
                </div>
            </nav>
            <div class="page-aside-bg"></div>

            <div class="auth-main">

                <div class="col-xs-11 col-sm-11 col-md-8 col-lg-8 h-100 d-flex align-items-center justify-content-center">
                    <div class="card border-0 p-0 m-0 w-100 h-100">
                        <div class="card-body">
                            <h1 class="page-heading text-left">Forgot Password</h1>
                            <form action="" method="post" class="mt-4" role="form" onSubmit={formSubmit}>
                                <div class="form-group">
                                    <label><strong>Your Email</strong></label>
                                    <div class='input'>
                                        <input type="email" name="email" placeholder="jerry@example.com" value={values.email}
                                            onChange={handleChange}
                                            required="required" />
                                        {error.length > 0 && (
                                            <Alert variant="danger">
                                                {error.map((val, index) => { val })}
                                            </Alert>
                                        )}

                                    </div>


                                </div>


                                <div class="form-group mt-4">
                                    <button type="submit" name="submit" class="btn btn-primary btn-block my-1 py-25">
                                        <b>Forget Password {` `}
                                            <svg width="18" height="12" class="ml-1 align-baseline" viewBox="0 0 24 18"
                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M14.2517 2.42589C13.711 1.87093 13.711 0.971172 14.2517 0.416217C14.7924 -0.138739 15.6691 -0.138739 16.2098 0.416217L23.5945 7.99516C24.1352 8.55012 24.1352 9.44988 23.5945 10.0048L16.2098 17.5838C15.6691 18.1387 14.7924 18.1387 14.2517 17.5838C13.711 17.0288 13.711 16.1291 14.2517 15.5741L19.2726 10.4211H1.38462C0.619914 10.4211 0 9.78483 0 9C0 8.21517 0.619914 7.57895 1.38462 7.57895H19.2726L14.2517 2.42589Z"
                                                    fill="white" />
                                            </svg>
                                        </b>

                                    </button>
                                </div>

                                <div class="form-check ps-0 text-right">
                                    <label class="form-check-label d-none">
                                        <input type="checkbox" checked class="form-check-input" name="rememberme" />
                                        <small class="form-text text-muted">Remember me</small>
                                    </label>
                                </div>


                                <div class="row pt-1 mt-3 border"></div>

                                <div class="text-center mt-4"
                                    style={{ fontWeight: "600", flexBasis: "100%", color: "#64687D", fontSize: "14px" }} >

                                    <span class="text">Have an account?</span> {` `}
                                    <Link to="/login" class="text-primary font-weight-bolder">{`Login`}</Link>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ForgetPassword